import React from "react";
import environmentSettings from "@constants/environmentSettings";
import { Helmet } from "react-helmet-async";

const MagicBlocksScript = () => {
    const workspaceId = String(environmentSettings.magicBlocksWorkspaceId ?? "");
    const experienceId = String(environmentSettings.magicBlocksExperienceId ?? "");
    const isTestMode = String(environmentSettings.magicBlocksTestMode ?? "") === "true";

    return (
        <Helmet>
            <script id="magicblocks-chatbot-script" type="text/javascript">
                {`window.MAGICBLOCKS = {
                workspace: ${JSON.stringify(workspaceId)},
                experience: ${JSON.stringify(experienceId)},
                config: {
                    style: 'dynamic',
                    ${isTestMode ? "mode: 'test'" : ''}
                }
            };
                (function() {
                    var s = document.createElement('script');
                    s.id = 'mbw-script';
                    s.type = 'text/javascript';
                    s.src = 'https://scripts.magicblocks.com/widget/latest?ws=' + window.MAGICBLOCKS.workspace + '&e=' + window.MAGICBLOCKS.experience;
                    (document.head || document.documentElement).appendChild(s);
                })();
            `}
            </script>
        </Helmet>
    );
};

export default MagicBlocksScript;
